  function getSave(){
    let moneyFormat = null;
    let comparePrice = 0
    setTimeout(()=>{
      $(".cart-items .cart-item").each((idx,el)=>{
        moneyFormat = $(el).attr("data-money-format")
        comparePrice = Number($(el).attr("data-compare-price")) + comparePrice
      })
     moneyFormat&& $(".custom_save").text(moneyFormat.replace("{{amount}}",(comparePrice/100).toFixed(2)))
    },0)
  }
  
  window.onload=getSave;
  document.addEventListener('cart::drawer::open',getSave);

  document.addEventListener('cart:update',getSave);
